export const regexp = {
    gosnumber:
        /^[АВЕКМНОРСТУХABEKMHOPCTYX]\d{3}[АВЕКМНОРСТУХABEKMHOPCTYX]{2}\d{2,3}$/i,
    taxi: /^[АВЕКМНОРСТУХABEKMHOPCTYX]{2}\d{3}\d{2,3}$/i,
    vin: /^(?=.*[0-9])(?=.*[A-z])[0-9A-Za-z]{17}$/,
};
